/* global overrideReasonOptions: false */
import {
  TABLET_MIN_WIDTH,
  CHOOSE_ALTERNATE_PRODUCT
} from '../utilities/constant_config';
import { validateCartPage, populatePage } from '../utilities/helper';
import {
  disabledArrowsAccessibility,
  initializeSelectMenuCreation,
  selectmenuChangeHandler
} from '../utilities/utility';

const $doc = $(document);
const monthDropdown = '.js-monthDropdown';
const clsActionItems = '.shipping-error';
const clsHidden = 'hidden';
const clsAternateProd = '.alternateProduct';
const clsAlternateItemName = `${clsAternateProd} ${clsAternateProd}--info__title`;
const clsCarousle = `${clsAternateProd}--bxslider`;
const clsRadioAlternate = '.js-alternateProduct';
const selectProduct = `${clsAternateProd}--replace`;
const resolutionType = '.resolutionType';
const selectedRadioOpt = `${clsActionItems}--options`;
const clsNext = '.js-nextStep';
const actionItemFormId = '#excludedProductsForm';
const clsProductParent = '.checkout-validation__exclusion';
const clsalternateProductCode = '.alternateProductCode';
const limitsRadioBtn = '.checkout-error-section__limits_radio';
const overrideReasonSection = '.override-reason';
const overrideReasonDropdown = '.override-reason-dropdown';
const overrideReasonValue = '.overrideSubmitValue';
const clsSupplyPeriodNext = '.js-supply-nextStep';
const idSupplyPeriodForm = '#actionItemForm';
const clsChangeSupplyPeriod = '.js-change-supplyPeriod';
const clsParentSupplyPeriod = '.supplyItems';
const clsdropDownHeight = '.supplyPeriod--date .ui-selectmenu-button';
const clsDropdownSupply = '.dropdownSupply';
const checkMonth = '.checkMonth';
const checkYear = '.checkYear';
let nextStepButtonFlag = false;
const optionsCarouselDesktop = {
  minSlides: 2,
  maxSlides: 2,
  slideWidth: 320,
  randomStart: false,
  controls: true,
  infiniteLoop: false,
  hideControlOnEnd: true,
  pagerCustom: '#bx-pager',
  margin: 10,
  prevSelector: '.bxslider-carousel__exclusions-prev',
  nextSelector: '.bxslider-carousel__exclusions-next',
  onSlideAfter: () => {
    disabledArrowsAccessibility(clsCarousle);
  },
  onSliderLoad: () => {
    disabledArrowsAccessibility(clsCarousle);
  }
};

const checkoutAlternateItem = {
  validateWeeksMonths() {
    let supplyTotalDuration;
    let supplyDropdown = '<option class="hidden"></option>';
    $(clsSupplyPeriodNext).prop('disabled', true);
    const $supplyPeriodParent = $(this).parents(clsParentSupplyPeriod);
    const $durationSupplyPeriod = $supplyPeriodParent.find(
      clsChangeSupplyPeriod
    );
    $durationSupplyPeriod.empty();
    const duration = $(this).val();
    supplyTotalDuration = $(this).data('max-supply-unit');
    const maxSupplyPeriodDuration = $(this).data('max-supply-duration');
    if (duration === 'Months' && maxSupplyPeriodDuration === 'Weeks') {
      supplyTotalDuration = parseInt(supplyTotalDuration / 4, 0);
    } else if (duration === 'Weeks' && maxSupplyPeriodDuration === 'Months') {
      supplyTotalDuration *= 4;
    }
    for (let i = 1; i <= supplyTotalDuration; i += 1) {
      supplyDropdown += `<option value='${i}'> ${i} </option>`;
    }
    $durationSupplyPeriod.html(supplyDropdown);
    $durationSupplyPeriod.selectmenu('refresh');
  },

  resizeProductCarousel() {
    if ($(window).width() > TABLET_MIN_WIDTH - 1) {
      $(clsCarousle).bxSlider(optionsCarouselDesktop);
      disabledArrowsAccessibility(clsCarousle);
    }
  },

  selectedResolution() {
    let checkedRadio = true;
    let alternateProductFlag = false;
    let $radioButtonParent;

    $(selectedRadioOpt).each((i, obj) => {
      if (!$(`input:radio[name='checkoutRadio${i}']`).is(':checked')) {
        checkedRadio = false;
        return false;
      }
      const radioOptionSelected = $(
        `input:radio[name='checkoutRadio${i}']:checked`
      ).val();
      $(resolutionType + i).val(radioOptionSelected);
      $radioButtonParent = $(obj).parents(clsActionItems);
      if (radioOptionSelected === CHOOSE_ALTERNATE_PRODUCT) {
        alternateProductFlag = true;
        $radioButtonParent.find(clsAternateProd).removeClass(clsHidden);
        ACC.utility.setEllipsis($(clsAlternateItemName));
      } else {
        $radioButtonParent.find(clsAternateProd).addClass(clsHidden);
      }
      return true;
    });
    if (checkedRadio && !alternateProductFlag) {
      $(clsNext).attr('disabled', false);
    } else {
      $(clsNext).attr('disabled', true);
    }
  },

  replaceProduct() {
    const alternateItemCode = $(this).attr('data-item-code');
    $(this)
      .parents(clsProductParent)
      .find(clsalternateProductCode)
      .val(alternateItemCode);
    $(clsAternateProd).addClass(clsHidden);
    if(!nextStepButtonFlag){
      nextStepButtonFlag = true;
      $(actionItemFormId).submit();
    }
  },

  submitActionItemForm() {
    // if "Adjust Quantity" to 0 and it's the last item in the cart,
    // then submit the limit resolution as if "Remove Item" was selected
    if (
      $('input[value="1005"]').is(':checked') &&
      parseInt($('#actual_quantity_value').text()) -
        $('#adjustmentQuantity').val() <=
        0 &&
      $('#add-minus').val() === 'true' &&
      $('#limitValidationCartSize').val() === 1
    ) {
      $('input[value="1006"]').prop('checked', true);
    }

    if(!nextStepButtonFlag){
      nextStepButtonFlag = true;
      $(actionItemFormId).submit();
    }
  },

  preventNextStepButton(){
    $('#ins-next-btn').css('pointer-events','none');
    let dataUrl = $('#ins-next-btn').attr('data-url');
    window.location.href= dataUrl; 
  },

  limitActionPreventNextSTepButton(){
    if(!nextStepButtonFlag){
      nextStepButtonFlag = true;
      $('#chhLimitsValidateForm').submit();
    }
  },

  getDurationValue() {
    validateCartPage(clsSupplyPeriodNext, clsChangeSupplyPeriod);
  },

  submitSupplyPeriodForm() {
    $(idSupplyPeriodForm).submit();
  },

  hideOverrideDropdown() {
    if ($(this).val() === '1007') {
      $(this)
        .closest('.checkout-error-section__option')
        .find('.override-reason')
        .removeClass('hidden');
    } else {
      $(this)
        .closest('.shipping-error--options__lable')
        .find('.override-reason')
        .addClass('hidden');
    }
  },

  setOverrideValue() {
    const overrideReasonsVar = $doc.find(overrideReasonSection);
    overrideReasonsVar.each(item => {
      const overrideSection = overrideReasonsVar[item];
      const overrideSelected = $(overrideSection)
        .find('.override-reason-dropdown')
        .val();
      $(overrideReasonValue + item).val(overrideSelected);
    });
  },

  populateDropdown() {
    const overrideReasonsVar = $doc.find(overrideReasonSection);
    overrideReasonsVar.each(item => {
      const overrideSection = overrideReasonsVar[item];
      populatePage(
        $.trim(
          $(overrideSection)
            .closest('.shipping-error-product')
            .find('.product-code')
            .text()
        ),
        $(overrideSection).find('.override-reason-dropdown')
      );
    });
  },

  init() {
    $(window).on('load', this.populateDropdown);
    this.resizeProductCarousel();
    $('.bx-prev,.bx-next').attr('role', 'button');
    $(clsChangeSupplyPeriod).selectmenu({
      classes: {
        'ui-selectmenu-menu': 'checkout-action-items-select-menu'
      }
    });
    $('.checkMonth,.checkYear,.psq-dropdown,.js-monthDropdown').selectmenu({
      classes: {
        'ui-selectmenu-menu': 'checkout-action-items-select-menu'
      }
    });
    $('.override-reason-dropdown').selectmenu();
    $doc.on('selectmenuchange', monthDropdown, this.validateWeeksMonths);
    $doc.on('change', limitsRadioBtn, this.hideOverrideDropdown);
    $doc.on('selectmenuchange', overrideReasonDropdown, this.setOverrideValue);
    $doc.on('click', clsDropdownSupply, this.getDurationValue);
    $doc.on('click', clsSupplyPeriodNext, this.submitSupplyPeriodForm);
    $doc.on('click', '.checkout_ActionItem_Excluded_Product_Btn', this.submitActionItemForm);
    $doc.on('click', '.checkout_ActionItem_Page_NextStep_Btn', this.preventNextStepButton);
    $doc.on('click', '.checkoutLimitsActionNextStepButton', this.limitActionPreventNextSTepButton);
    $doc.on('click', selectProduct, this.replaceProduct);
    $doc.on('click', clsRadioAlternate, this.selectedResolution);
    $doc.on('click', clsdropDownHeight, ACC.utility.setDropdownHeight);
    $doc.on(
      'selectmenucreate',
      '.override-reason-dropdown',
      initializeSelectMenuCreation
    );
    $doc.on(
      'selectmenuchange',
      '.override-reason-dropdown',
      selectmenuChangeHandler
    );
  }
};
checkoutAlternateItem.init();
export default checkoutAlternateItem;
